import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import "./PrivacyPolicy.css";

function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="privacyContainer page-content ">
      <Helmet>
        <title>Hotelzify - Privacy Policy</title>
        <meta
          name="description"
          content="Privacy Policy of Hotelzify, get more info from https://hotelzify.com"
        />
        <link rel="canonical" href={`https://hotelzify.com/privacy-policy`} />
        <meta property="og:title" content={"Hotelzify's Privacy Policy"} />
        <meta property="og:type" content={"website"} />
        <meta
          property="og:url"
          content="https://hotelzify.com/privacy-policy"
        />

        <meta
          property="og:image"
          content={"https://ik.imagekit.io/hotelzifyprod/logo1.png"}
        />

        <meta
          property="og:description"
          content={
            "Increase the online presence by using Hotelzify's AI powered Ads and booking engine to drive more bookings."
          }
        />
      </Helmet>
      <nav>
        <img
          src="https://ik.imagekit.io/hotelzifyprod/logo1.png"
          alt="logo"
          width={"120px"}
        />
        {/* Hotelzify */}
        <div>
          <a href="tel:+917975660291">Call Us</a>
        </div>
      </nav>
      <div>
        <section>
          <div>
            <h1 className="mb-32">Privacy Policy</h1>
            <div>EFFECTIVE DATE: APRIL 30, 2022</div>
            <p>
              Welcome to Hotelzify,("us", "we", or "our") operates the
              Hotelzify.com website and the Hotelzify mobile application (herein
              after referred to as the "Service"). Our Privacy Policy explains
              how we collect, use, disclose, and protect information that
              applies to our Service, and your choices about the collection and
              use of your information. This policy sets out how Hotelzify
              collects and uses the information that we collect about you when
              you use the Hotelzify services. This policy also explains the
              choices that you can make about the way that we use your
              information.By using the Website and/or registering yourself at
              Hotelzify.com you authorize us to contact you via email or phone
              call or SMS and offer you our services, imparting product
              knowledge, offer promotional offers running on the website &amp;
              offers offered by the associated third parties, for which reasons,
              personally identifiable information may be collected. And
              irrespective of the fact that you have also registered yourself
              under DND or DNC or NCPR service, you still authorize us to give
              you a call from Hotelzify for the above-mentioned purposes till
              365 days of your registration with us.
            </p>
          </div>
        </section>
        <div>
          <h2>1. DEFINITIONS</h2>
          <ol>
            <li>
              <strong>1.1. “Act”</strong> means Information Technology Act, 2000
              and any amendments thereof;
            </li>
            <li>
              <strong>1.2. “Applicable Law(s)”</strong> means all statutes,
              enactments, acts of legislature or parliament, ordinances, rules,
              bye-laws, regulations, notifications, policies, directions,
              directives and orders as such are in effect as of the date hereof
              or as may be amended, modified, enacted or revoked from
              time-to-time hereafter or other governmental restrictions or any
              similar form of decision of, or determination by any government,
              statutory authority, tribunal, board, court having jurisdiction
              over the matter in question in India;
            </li>
            <li>
              <strong>1.3. “App” or “Application”</strong> shall mean a mobile
              application of the Company, that is available on cellular devices
              through the App Store or the Play Store through which the Company
              makes its Services available to registered users;
            </li>
            <li>
              <strong>1.4. “Business Partner(s)”</strong> shall mean such
              entities that We have a business partnership with, as updated from
              time to time;
            </li>
            <li>
              <strong>1.5. “Consent”</strong> shall mean as per Clause (III) of
              the Privacy Policy;
            </li>
            <li>
              <strong>1.6. “Database”</strong> shall mean an organized
              collection of structured information, or data, that is stored
              electronically in Our computer systems.
            </li>
            <li>
              <strong>1.7. “Log Data”</strong> shall include internet protocol
              address, browser type, browser language, referring URL, files
              accessed, errors generated, time zone, operating system and other
              visitor details collected in Our log files, the pages of our
              Website or App that You visit, the time and date of Your visit,
              the time spent on those pages/ and other statistics;
            </li>
            <li>
              <strong>1.8. “Payment Gateway”</strong> means the electronic
              payment service provided on the Application for authorizing debit
              card, credit card, net banking, online wallet or any other method
              of payments included by the Company for processing all payments to
              be made by Users;
            </li>
            <li>
              <strong>1.9. “Purpose” includes,</strong>
              <ol>
                <li>1.9.1. To provide and maintain our Service.</li>
                <li>1.9.2. To notify you about changes to our Service.</li>
                <li>
                  1.9.3. To allow you to participate in interactive features of
                  our Service when you choose to do so.
                </li>
                <li>1.9.4. To provide customer support.</li>
                <li>
                  1.9.5. To gather analysis or valuable information so that we
                  can improve our Service.
                </li>
                <li>1.9.6. To monitor the usage of our Service.</li>
                <li>1.9.7. To detect, prevent and address technical issues.</li>
                <li>
                  1.9.8. To provide you with news, special offers and general
                  information about other goods, services and events which we
                  offer that are similar to those that you have already
                  purchased or enquired about unless you have opted not to
                  receive such information.
                </li>
              </ol>
              <ol>
                <li>
                  <strong>1.10. “Personal Information” shall mean:</strong>{" "}
                  Information such as
                  <ol type="a">
                    <li>Name of the User;</li>
                    <li>Email Address, as provided by the User;</li>
                    <li>Contact Number;</li>
                    <li>Gender;</li>
                    <li>Age;</li>
                    <li>Location of the User, as provided by the User;</li>
                    <li>Financial information;</li>
                    <li>
                      Such other information of the User, as and when collected.
                    </li>
                  </ol>
                </li>
                <li>
                  1.11. “Privacy Policy” shall mean this document that governs
                  usage of data by Us.
                </li>
                <li>
                  1.12. “Property” shall mean any hostel, homestay, resort,
                  hotel that is being registered with Us.
                </li>
                <li>
                  1.13. “Rules” means the Information Technology (Reasonable
                  Security Practices and Procedures and Sensitive Personal Data
                  or Information) Rules, 2011;
                </li>
                <li>
                  1.14. “User”, or “You”, or “Your” shall refer any person or a
                  person representing an entity under the laws of India that
                  accesses the Website or the App;
                </li>
                <li>
                  1.15. “User Data” shall mean the cumulative data obtained by
                  Us, from User activity on the Website or App;
                </li>
                <li>
                  1.16. “Website” shall mean the web services of Hotelzify made
                  available on the world wide web, “www” and bearing domain name
                  www.hotelzify.com.
                </li>
              </ol>
            </li>
          </ol>
          <ol>
            <h2>2. PRIVACY POLICY</h2>
            <ol>
              <li>
                2.1. This privacy policy (“Privacy Policy”) governs Your use of
                the Our Website and App, as we endeavor to provide Users with
                Our Services including to create and maintain a website for
                properties such as hostels, hotels, homestays, through which
                potential guests may book rooms on such property (“Services”).
              </li>
              <li>
                2.2. This Privacy Policy has been duly framed in accordance with
                the Act and the Rules to ensure maximum protection to the
                information provided by You. This electronic record is generated
                by a computer system and does not require any physical or
                digital signatures.
              </li>
              <li>
                2.3. We, (“Hotelzify”) have Our registered office at S4-101,
                Greenwood Regency, Bengaluru, Karnataka 560035 bearing CIN
                U72900KA2022PTC167171 (hereinafter referred to as “We”, “Us”,
                “Company” or “Our” which expression shall mean and include its
                affiliates, successors and permitted assigns), wherein We affirm
                that this Website and App are solely owned by Us.
              </li>
              <li>
                2.4. By browsing Our Website or registering on Our App, You
                agree to abide by the terms and conditions pertaining to
                collection, retention, and use of information set forth in this
                Privacy Policy. If You do not agree to the Privacy Policy, You
                may refrain from browsing Our Website and/or registering on the
                App and in this case, We will be unable to provide you with Our
                Services.
              </li>
              <li>
                2.5. This Privacy Policy provides You with details about the
                manner in which Your data is collected, stored and used by Us.
                You are advised to read this Privacy Policy carefully. By
                Browsing Our Website or registering on Our App, You expressly
                give Us consent to use and disclose Your Personal Information in
                accordance with this Privacy Policy, wherever necessitated. If
                You do not agree with the terms of the Privacy Policy, please do
                not use or access Our Website or avail Our Services through Our
                App.
              </li>
              <li>
                2.6. Hotelzify is not targeted towards minors. The target
                audience and content thereof shall be targeted towards adults
                who are above the above of 18 (Eighteen). In the event the
                Application and/ or the Website has been accessed and / or any
                Personal Information has been inadvertently collected from a
                person / minor not eligible as per this clause, kindly contact
                Hotelzify at{" "}
                <a href="mailto:support@hotelzify.com">support@hotelzify.com</a>{" "}
                and Hotelzify shall delete such Personal Information (defined
                below) as soon as possible.
              </li>
            </ol>
          </ol>
          <h2>3. CONSENT OF USER</h2>
          <ol>
            <li>
              3.1. If You are a business entity, You warrant and represent that
              You are accessing the Application or Website for business or
              related purposes only and the entity holds valid registrations for
              the relevant statutory authority, where applicable.
            </li>
            <li>
              3.2. If the User is accessing the Application on behalf of, a
              corporate entity, User warrants and represents that User has
              requisite authority to bind that corporate entity and that User is
              duly authorized by the business entity to accept the Privacy
              Policy and User has the authority to bind that business entity to
              the Privacy Policy.
            </li>
            <li>
              3.3. If the User is a natural person, he/she is above the age of
              18 (eighteen) and is eligible under the Indian Contract Act, 1872
              to enter into a valid agreement and be bound by the terms of this
              Privacy Policy.
            </li>
            <li>
              3.4. You acknowledge that Your Consent is being obtained for the
              Purpose defined under Clause 1 (7) above.
            </li>
            <li>
              3.5. ACCESSING, BROWSING OR OTHERWISE USING THE APPLICATION AND/
              OR WEBSITE INDICATES YOUR ACCEPTANCE OF ALL THE TERMS IN THIS
              PRIVACY POLICY. PLEASE READ THE PRIVACY POLICY CAREFULLY BEFORE
              PROCEEDING. YOU DECLARE YOUR WILLINGNESS TO ABIDE AND BE BOUND BY
              THS PRIVACY POLICY THROUGH YOUR USE OF THE APPLICATION AND/ OR
              WEBSITE. IF YOU DO NOT AGREE WITH THE TERMS OF USE, PLEASE DO NOT
              USE THE APPLICATION AND THE WEBSITE. This Privacy Policy will be
              effective immediately upon Your acceptance of Our Privacy Policy,
              Your use of Our Website being indicative of such acceptance. This
              Privacy Policy shall be enforceable, in the same manner as any
              other written agreement.
            </li>
          </ol>
          <h2>4. POINTS OF DATA COLLECTION</h2>
          <ol>
            <li>
              4.1. Hotelzify receives information only when the Users enter
              their Personal Information on the Application and /or the Website.
            </li>
            <li>
              4.2. We collect information from Users when Users access Our
              Website and / or register with Us, through Our App. Further, in
              cases where You are looking to avail Our Services, we may ask You
              to provide Your Personal Information such as a phone number for
              verification and other information about Your Property such as
              name, amenities, description of the Property amongst others. In
              case You are providing information to Us, on behalf of another
              person, You should only do so, if You are duly authorised by them
              under Applicable Laws.
            </li>
            <li>
              4.3. We may also request Personal information during the course of
              provision of Our Services, to provide the You with other benefits
              of Our Services.
            </li>
          </ol>
          <h2>5. COLLECTION OF INFORMATION</h2>
          <ol>
            <li>
              5.1. User information – When You use Our Website or App, We
              automatically receive and record information from Your device and
              applicable browser. Such information may include, location of Your
              device, Your device storage, Your IP address, cookie information,
              software and hardware attributes, unique device ID etc. Most of
              the information We collect during Your use of Our Website or App,
              is Your device and hardware IDs and device type, and basic usage
              stats about Your device and general use of Our Services does not
              by itself identify You to Us, though it may be unique or consist
              of or contain information that You consider personal.
              Specifically, We collect, retain and use information collected,
              retained and shared through Facebook Platform, Twitter, Google and
              YouTube, according to the applicable terms and conditions of their
              privacy policies.
            </li>
            <li>
              5.2. Personal Information and Database – On the basis of Your
              usage of Our Website/App we may also export Your Personal
              Information from Our Database to any other third -party as
              permitted under Applicable Law (collectively referred to as “User
              Data”).
            </li>
            <li>
              5.3. Registration – In order to avail Our Services, You shall have
              to register yourself on Our App. We shall record Your Personal
              Information and other information about Your Property as furnished
              by You onto the App.
            </li>
            <li>
              5.4. User history and preferences – We save Your query terms as
              well as Your statement of experience with us. These may be
              associated with the unique registration ID of Your device. We also
              save Your recommendations and preferences for Our Services, as
              recorded through Your use of the Services and use them for
              personalization features.
            </li>
            <li>
              User 5.5. Cookies – When You use Our Website/App, We may send one
              or more cookies. “Cookies” are small files placed on your hard
              drive that assist us in providing Our Services. Cookies can also
              help us provide information that is targeted to your interests.
              Most cookies are “session cookies,” meaning that they are
              automatically deleted from your storage at the end of a session.
              We use cookies to improve the quality of Our Website and Services
              by storing User preferences and tracking User information. Cookies
              shall have limited scope, either for the purpose of User
              enrolment/registration for imparting Services. You are always free
              to decline our cookies if Your browser/ mobile application
              permits, although in that case You may not be able to use certain
              features of the same. Additionally, you may encounter “cookies” or
              other similar devices on certain pages of the Website/App that are
              placed by third parties. We do not control the use of cookies by
              third parties.
            </li>
          </ol>
          <h2>6. USE OF INFORMATION</h2>
          <ol>
            <li>
              6.1 We collect Personal Information primarily for the Purpose as
              defined in Clause 1 (7) and to enable us to provide Our Services
              to You or help you browse Our Website, seamlessly. We may share
              Your Personal Information in anonymized form any other third party
              as required under Applicable Law in order to perform Our Services.
              Any User Data that We have access over is never shared without the
              Your consent.
            </li>
            <li>
              6.2 The Personal Information We collect allows Us to keep You
              posted on Our latest announcements, upcoming events, including
              confirmations, security alerts and support and administrative
              messages, that You have specifically requested for. It also helps
              Us to improve Our Services. If You do not want to be on Our
              mailing list, You can opt out at any time by unsubscribing to Us,
              through the usage of Your mail ID.
            </li>
            <li>
              6.3 From time to time, We may use Your Personal Information to
              send important notices, such as communications and changes to Our
              Terms of Use or Privacy Policy. Since, this information is
              important to Your interaction with Us, You may only opt out of the
              same, only after communicating with Us or choosing to delete Your
              profile with Us. We may also use Personal Information for internal
              purposes such as data analysis and research to improve Our
              Services, products and customer communication.
            </li>
            <li>
              6.4 We collect Non-Personally Identifiable Information about Our
              Users generally to improve features and functionality of Our
              Website/App. We may analyze trends through aggregated demographic
              and psychographic offers to Users. We may also share this
              Non-Personally Identifiable Information with Our partners to allow
              them to assist Us in delivering tailored advertisements,
              promotions, deals, discounts, and other offers to You when You use
              the Services. We collect information from You when You use Our
              Website and decide to avail Services provided by Us on Our App.
            </li>
            <li>
              6.5. We may also collect information about You through other
              methods, including research surveys or information We obtain from
              third parties, including verification services, data services, as
              well as public sources. We shall not be responsible for any breach
              of privacy, or any issues related to accuracy of such third party
              data or third party information.
            </li>
            <li>
              6.6. For the use of the Services, you may be required to pay on
              the Application with a credit card, wire-transfer, or debit card
              through the Application’s third party Payment Gateway provider and
              such third party Payment Gateway provider may be required to
              collect certain financial information from you including, but not
              restricted to, your credit/debit card number or your bank account
              details (collectively referred to as “Financial Information”). All
              Financial Information collected from the Users by the third party
              Payment Gateway providers will be used only for billing and
              payment processes. The verification of the Financial Information
              shall be accomplished only by the User through a process of
              authentication in which the Company shall have no role to play.
              The Company is not responsible for the acts or omissions of the
              third party Payment Gateway providers.
            </li>
            <li>
              6.7. Personal Information, personally identifiable information and
              / or Financial Information shall be collected by the Application
              and / or the Website on an ongoing basis, without need for
              further, separate consent from the User (aside from the acceptance
              of this Privacy Policy) for one or more of the Purposes mentioned
              under Clause 1 (7).
            </li>
          </ol>
          <h2>7. SHARING</h2>
          <ol>
            <li>
              7.1. We may share with third parties the location of Your device
              in order to improve and personalize Your experience of the
              Service.
            </li>
            <li>
              7.2. We may share with third parties certain pieces of
              non-personal information, such as the number of Users who are
              using Our Services, users who clicked on a particular
              advertisement or who skipped a particular advertisement, as well
              as similar aggregated information. Such information does not
              identify You individually.
            </li>
            <li>
              7.3. We may share with third parties Your unique device ID. While
              such information does not by itself identify You to Us, it may be
              unique or consist of or contain information that You consider
              personal, however such information does not identify You
              individually.
            </li>
            <li>
              7.4. We provide such information to trusted businesses or persons
              for the purpose of processing Personal Information and or other
              information on Our behalf. We require that these parties agree to
              process such information based on Our instructions and in
              compliance with this Privacy Policy and any other appropriate
              confidentiality and security measures.
            </li>
            <li>
              7.5. Advertisers: We allow advertisers and/or merchant partners
              (“Advertisers”) to choose the demographic information of Users who
              will see their advertisements and/or promotional offers and You
              agree that We may provide any of the information We have collected
              from You in non-personally identifiable form to an Advertiser, in
              order for that Advertiser to select the appropriate audience for
              those advertisements and/or offers.
            </li>
          </ol>
          <h2>8. SECURITY</h2>
          <ol>
            <li>
              8.1. The security of Your Personal Information and User Data is
              important to Us. We take precautions, including administrative,
              technical and physical measures, to safeguard Your Personal
              information against loss, theft and misuse, as well as against
              unauthorized access, disclosure, alteration and destruction. Any
              Personal Information obtained by Us on Our Website or App shall be
              encrypted. Our Website/App has various electronic, procedural and
              physical security measures in place to protect the loss, misuse
              and alteration of information, or any accidental loss, destruction
              or damage to data. When You submit Your information, Your
              information is protected through Our security systems.
            </li>
            <li>
              8.2.Hotelzify Private Limited will take all the steps reasonably
              necessary to ensure that your data is treated securely and in
              accordance with this Privacy Policy and no transfer of your
              Personal Data will take place to an organisation or a country
              unless there are adequate controls in place including the security
              of your data and other personal information.
            </li>
            <li>
              8.3. It is expressly stated that the Application shall not be
              responsible for any breach of security or for any action of any
              third parties that receive Users’ personal data or events that are
              beyond the reasonable control of the Application or Hotelzify
              including, acts of government, computer hacking, unauthorized
              access to computer data and storage device, computer crashes,
              breach of security and encryption, etc.
            </li>
          </ol>
          <h2>9. STORAGE OF DATA</h2>
          <ol>
            <li>
              9.1. We will store Your Personal Information and User Data which
              shall be retained up to such period wherein such information is
              necessary to be stored and for such time period as may be
              permissible under Applicable Laws. In the event You terminate your
              Services with Us, Your express consent to this Privacy Policy,
              shall be understood as withdrawn.
            </li>
            <li>
              9.2. In the event You decide to stop availing Services, including
              but not limited to, deleting the Personal Information stored with
              Us, the same shall be honored by Us, if requested in writing to{" "}
              <b>support@hotelzify.com</b>. In the event You wish to delete the
              Personal Information stored with Hotelzify, the same shall be
              honored by Hotelzify if requested in writing to{" "}
              <b>support@hotelzify.com</b>. Any Personal Information deleted by
              Hotelzify shall not be available to restore under any
              circumstances.
            </li>
            <li>
              9.3. We will keep records of communications, including but not
              limited to, phone calls received and made for making enquiries,
              orders, feedback and / or any other purposes for rendering
              Services effectively and efficiently. We shall be the exclusive
              owner of such data and records.
            </li>
            <li>
              9.4. As a rule, all records are regarded as confidential.
              Therefore, will not be divulged to any third party, unless
              required as per the terms of this Privacy Policy or under
              Applicable Laws.
            </li>
          </ol>
          <h2>10. ACCESSING THIRD PARTY WEBSITES</h2>
          <div>
            Our Website/App may contain links to other websites. Please note
            that when you click on one of these links, you are entering another
            website for which We have no responsibility. We encourage you to
            read the privacy statements of all such sites as their policies may
            be materially different from this Privacy Policy. Of course, you are
            solely responsible for maintaining the secrecy of your membership
            account information. Please be very careful, responsible, and alert
            with this information, especially whenever you are online.
          </div>
          <h2>11. PROTECTION OF CHILDREN</h2>
          <div>
            Use of Our Services is available only to persons who can form a
            legally binding contract under the relevant local laws applicable to
            Your country. If you are a User under the age of 18 (“Child User”),
            You may use Our Services only with the involvement of a parent or
            guardian. Please ensure that You have adequate consent from Your
            parent or guardian to access Services in accordance with the present
            Privacy Policy.
          </div>
          <div>
            If You are the parent or guardian of a Child User, please advise
            Your child of the risks of posting Personal Information in order to
            avail Our Services or other online services, and that any
            information posted may be used by third parties without restriction.
            Notwithstanding anything contained herein, We shall always presume
            that every User has adequate consent and free-will to access
            Services and to enter into a legally enforceable contract with Us.
          </div>
          <div>
            We also reserve the right to remove, at Our sole discretion, any
            content or material posted by a User which may be of defamatory or
            sexual nature or offensive to other Users in any manner, and take
            appropriate legal action against such User.
          </div>
          <h2>12. MECHANISM OF SHARING DATA WITH THIRD PARTIES</h2>
          <ol>
            <li>
              12.1 We may disclose Personal Information about You to Our
              representatives and other third parties. We also reserve the right
              to disclose your Personal Information to third parties in an
              anonymous or aggregate form, to understand customer trends and
              patterns and manage and improve our business relationships.
            </li>
            <li>
              12.2 We may provide Your Personal Information to our Business
              Partners, representatives and third party processors to administer
              and process for the Purposes notified to you in this Privacy
              Policy, and We may also share such details with third parties,
              including but not limited to, auditors or legal advisors to obtain
              professional advice. Any such processing will be governed by an
              agreement in the form required as per Applicable Law, preserving
              any and all of Your statutory data protection rights. You
              authorise Us to exchange, transfer, share, part with all or any of
              your Personal Information, across borders and from Your country to
              any other countries across the world with our
              affiliates/agents/third party service providers/partners/banks and
              financial institutions for the Purposes specified under this
              Privacy Policy or as may be required by Applicable Law.
            </li>
            <li>
              12.3 You acknowledge that We may be obligated by law to disclose
              and / or transfer your Personal Information with judicial and / or
              quasi – judicial courts and government agencies in certain
              instances such as for verification of identity or for prevention,
              detection, investigation, prosecution, and punishment for
              offences, or in compliance with Applicable Laws. In the event of
              any regulatory inquiry, including court issued warrants or written
              request from any agencies of the Government, supported by
              warrants, We shall have no option but to de-encrypt the Personal
              Information to the extent sought and share the same with such
              regulator or court or appropriate authority upon receiving
              specific warrant from such authority issued by a competent court.
              In such an event We shall not be liable in any way for such
              disclosure and We shall not be responsible to either inform Users
              or seek Users’ prior approval.
            </li>
            <li>
              12.4 Notwithstanding the above, we are not responsible for the
              confidentiality, security or distribution of Your Personal
              Information by third party (ies) outside the scope of our
              agreement with such third party (ies), in accordance with Clause
              (VI). We will not be responsible for any breach of security or for
              any actions of any third parties or events that are beyond Our
              reasonable control, including but not limited to, acts of
              government, computer hacking, unauthorized access to computer data
              and storage device, computer crashes, breach of security and
              encryption, poor quality of internet service and / or telephone
              service of the User etc.
            </li>
            <li>
              12.5 We may share Your Personal Information with Our other
              corporate and/or associate entities and affiliates or government
              officials or law enforcement officials to; (a) help detect and
              prevent identity theft, fraud and other potentially illegal acts
              and cyber security incidents, to help protect the property and
              rights of Us or any other third party, or to protect the safety of
              the public or any person, or to prevent or stop any illegal
              activity, (b) help and detect co-related/related or multiple
              accounts to prevent abuse of our services.
            </li>
          </ol>
          <h2>13. PRINCIPLES FOR PROTECTION OF PRIVACY</h2>
          <ol>
            <li>
              <strong>13.1. Commitment to Privacy.</strong> The App and Website
              are strongly committed to Users’ right to privacy and to keeping
              Users’ Personal Information and Financial Information secure. To
              earn Users’ trust and confidence, we are fully disclosing our
              privacy practices. We encourage Users to read our Privacy Policy
              to understand what types of Personal Information we collect and
              how we use this information.
            </li>
            <li>
              <strong>13.2. Applicability.</strong> This Privacy Policy sets
              forth the reasonable security practices and procedures adopted by
              Us and shall apply to the use, disclosure and sharing Personal
              Information provided by the Users of the Website and /or App which
              is owned and operated by Us. This policy is equally applicable on
              the visiting the Website and /or App or using Our Services. The
              Privacy Policy outlines the various measures undertaken by Us to
              provide Users with a convenient and safe online/ experience, while
              maintaining and safeguarding the confidentiality, integrity, and
              security of Users’ Personal Information, during storage and
              transmission through the world wide web. This Privacy Policy
              explains how We protects Personal Information provided by Users
              through the Website and /or App and how We store and use that
              information, to deliver the Services on the App.
            </li>
            <li>
              <strong>13.3. Choice.</strong> You may choose whether / not to
              provide your Personal Information Us. If you choose not to provide
              the Personal Information the Website and /or App requests, you may
              still visit the Website and /or App, but you may be unable to
              access the Services. If you choose to have avail Our Services, We
              will naturally continue to contact you in connection with the said
              Services. We neither collect nor store your biometric information.
            </li>
            <li>
              <strong>13.4. Access/Accuracy.</strong> To the extent that You do
              provide Us with Personal Information, We wish to maintain
              accurate, true and complete Personal Information. When We collect
              Personal Information from You, Our aim is to be able to reach out
              to You. You should keep Your information updated and correct. If
              for any reason Your information is inaccurate, You may send
              updates and corrections about Your Personal Information to Us, and
              We shall make reasonable efforts to incorporate the changes.
            </li>
            <li>
              <strong>13.5. Change in Policy</strong> This Privacy Policy is
              subject to change at any time, and it is advised that Users review
              this Privacy Policy periodically. Any change to this Privacy
              Policy will become effective as soon as it is posted or linked to
              the revised Privacy Policy on the Website. Users shall receive a
              notification whenever there is a change in our Policy on Users’
              registered email ID and the issuance of the notification shall
              constitute a fair amendment of the Privacy Policy.
            </li>
            <li>
              <strong>13.6. Retraction of User Consent</strong> If at any time
              such changes are not agreeable to a User, then the User may
              terminate his registration with the Website, stop availing Our
              Services and usage of the Website. Such termination and / or
              stopping of further use shall not result in any automatic deletion
              of Users’ Personal Information already stored with Us and We take
              no responsibility or makes no representation which would imply
              otherwise. However, We can assure you that the User’s Personal
              Information will be deleted or ceased to be retained by Us within
              reasonable time as permitted under Applicable Laws.
            </li>
            <li>
              <strong>13.7. Users’ Responsibility</strong> It shall be the
              responsibility of the Users to read and assess such changes in the
              Privacy Policy once such notifications have been sent to Users’
              registered email ID.
            </li>
          </ol>
          <h2>14. EMAIL NOTIFICATIONS</h2>
          <div>
            You may be contacted, by email or other means; for example, We may
            send You promotional offers on behalf of other businesses, or
            communicate with You about Your use of the Service. Also, We may
            receive a confirmation when You open an email from Us. This
            confirmation helps Us improve Our service. If You do not want to
            receive email or other mail from Us, please indicate Your preference
            by clicking on the “Unsubscribe” link at the bottom of the email or
            changing Your email settings on Your account settings page. Please
            note that if You do not want to receive legal notices from Us, those
            legal notices will still govern Your use of the service, and You are
            responsible for reviewing such legal notices for changes.
          </div>
          <h2>15. PURGING OF PERSONAL INFORMATION</h2>
          <div>
            Users’ Personal Information may be stored with Us for a period of
            time after the User ceases to access or use Our Services for the
            purposes mentioned in this Privacy Policy as permitted under
            Applicable Laws and the same may be eventually erased / purged /
            removed from our Database by writing to us at{" "}
            <b>support@hotelzify.com</b>
          </div>
          <h2>16. RIGHT TO INJUNCTIVE RELIEF</h2>
          <div>
            It is acknowledged and admitted by the User that a breach of the
            Privacy Policy by the User can cause irreparable damage to Us, and
            such damages may or may not be entirely quantifiable in monetary
            terms. Therefore, in the event of a breach of this Privacy Policy by
            the User, the User acknowledges that We shall have a prima facie
            case and a favorable balance of convenience to seek an injunctive
            relief to stop such continuing breach from a court of competent
            jurisdiction.
          </div>
          <h2>17. LIMITATION OF LIABLITY</h2>
          <div>
            THE WEBSITE, APPLICATION, AND OUR SERVICES ARE PROVIDED BY THE
            COMPANY ON AN &quot;AS IS&quot; AND &quot;AS AVAILABLE&quot; BASIS.
            ALL WARRANTIES WHETHER EXPRESS, IMPLIED, STATUTORY OR OTHERWISE,
            INCLUDING WITHOUT LIMITATION ANY IMPLIED WARRANTIES AS TO
            NON-INFRINGEMENT, CORRESPONDENCE WITH DESCRIPTION, MERCHANTABILITY
            OR FITNESS FOR A PARTICULAR PURPOSE ARE EXCLUDED TO THE FULLEST
            EXTENT PERMITTED BY LAW.
          </div>
          <div>
            NO LIABILITY ARISING OUT OF ANY VIOLATION OF DATA PRIVACY LAW IN ANY
            OTHER COUNTRY OTHER THEN REPUBLIC OF INIDA SHALL RESIDE WITH US. THE
            USERS OF SUCH COUNTRY (OTHER THAN REPUBLIC OF INDIA) NEED TO BE
            AWARE OF THE DATA PROTECTION LAWS OF THAT COUNTRY AND ACCORDINGLY
            ASSESS THE RISK SINCE HOTELZIFY CLEARLY DISCLAIMS ALL RESPONSIBILITY
            RELATED TO PROTECTION OF SUCH DATA.
          </div>
          <div>
            WITHOUT LIMITING THE GENERALITY OF ABOVE CLAUSE, WE MAKE NO WARRANTY
            THAT (I) WE WILL MEET USERS’ REQUIREMENTS OR THAT USERS USE OF THE
            WEBSITE/APP, OR ACCESS TO THE SAME, WILL BE UNINTERRUPTED, TIMELY,
            SECURE OR ERROR-FREE (II) THE QUALITY OF THE WEBSITE/APP WILL MEET
            USERS’ EXPECTATIONS.
          </div>
          <div>WE SHALL NOT BE LIABLE FOR:-</div>
          <ul>
            <li>
              i. ANY LOSS THAT USERS MAY INCUR AS A CONSEQUENCE OF UNAUTHORIZED
              USE OF USERS ACCOUNT OR ACCOUNT INFORMATION;
            </li>
            <li>
              ii. ANY INTERRUPTION OR NON-AVAILABILITY OF THE WEBSITE/APP DURING
              PERIODIC MAINTENANCE OR FOR ANY OTHER REASON INCLUDING BUT NOT
              LIMITED TO SYSTEMIC FAILURES AND ACTS OF GOD;
            </li>
            <li>
              iii. ANY INACCURACY, ERROR, OMISSION, INTERRUPTION, COMPLETENESS,
              DELETION, DEFECT, FAILURE OF PERFORMANCE, COMPUTER-VIRUS,
              COMMUNICATION LINE FAILURE, ALTERATION OF, OR ANY USE OF CONTENT
              HEREIN, REGARDLESS OF CAUSE, FOR ANY DAMAGES RESULTING THERE FROM;
              OR
            </li>
            <li>
              iv. ANY LOSS OF OPPORTUNITY, GOODWILL OR REPUTATION; OR ANY
              INDIRECT OR CONSEQUENTIAL LOSS OR DAMAGE ARISING HOWSOEVER;
            </li>
            <li>
              v. ACCURACY, CORRECTNESS OR ORIGINALITY OF ANY DATA INCLUDING ALL
              INDICES PUBLISHED ON THE WEBSITE/APP WHETHER THE SAME IS THIRD
              PARTY DATA OR OTHERWISE.
            </li>
            <li>
              vi. ANY LOSS OF PROFITS, SALES, BUSINESS OR REVENUE; BUSINESS
              INTERRUPTION; LOSS OF ANTICIPATED SAVINGS; LOSS OF BUSINESS
              OPPORTUNITY, GOODWILL OR REPUTATION; OR ANY INDIRECT OR
              CONSEQUENTIAL LOSS OR DAMAGE HOWSOEVER ARISING.
            </li>
          </ul>
          <p>
            IN NO EVENT SHALL COMPANY, ITS DIRECTORS, OFFICERS, EMPLOYEES,
            AFFILIATES, AGENTS OR CONTRACTORS BE LIABLE FOR ANY COMPENSATORY,
            DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL OR PUNITIVE DAMAGES,
            LOSS OF DATA, INCOME OR PROFIT, LOSS OF OR DAMAGE TO PROPERTY, OR
            ANY CLAIMS OF THE USERS OR OTHER THIRD PARTIES WHATSOEVER WITH
            RESPECT
          </p>
          <p>
            TO THE APPLICATION OR WEBSITE REGARDLESS OF THE LEGAL THEORY ON
            WHICH THE CLAIM IS BASED, INCLUDING, WITHOUT LIMITATION, ANY DAMAGES
            THAT RESULT FROM ANY MISTAKE, OMISSION, VIRUS, DELAY OR INTERRUPTION
            IN OPERATION OR SERVICE OR FAILURE OF PERFORMANCE, WHETHER OR NOT
            RESULTING FROM AN ACT OF GOD, COMMUNICATIONS FAILURE, THEFT OR
            OTHERWISE. THE COMPANY SHALL NOT BE LIABLE FOR ANY LOSSES OR DAMAGES
            WHATSOEVER RESULTING FROM ANY FAILURE OF THE INTERNET.
          </p>
          <p>
            THE COMPANY DOES NOT GUARANTEE THAT ANY CONTENT, INFORMATION,
            SOFTWARE OR OTHER MATERIAL ACCESSIBLE THROUGH THE APPLICATION OR THE
            WEBSITE WILL BE FREE OF VIRUSES, “WORMS”, “TROJAN HORSES”, OR THEIR
            HARMFUL COMPONENTS. THE COMPANY’S ENTIRE LIABILITY AND THE USER’S
            SOLE AND EXCLUSIVE REMEDY WITH RESPECT TO THE USE THE WEBSITE/APP IS
            TO CEASE USING THE SAME WITH IMMEDIATE EFFECT.
          </p>
          <p>
            USERS ACKNOWLEDGE THAT THE EXCLUSIONS AND LIMITATIONS ON OUR
            LIABILITY SET OUT IN THIS CLAUSE ARE DISTINCT AND SEPARATE
            PROVISIONS. IF ANY PROVISION OR PART-PROVISION OF THIS CLAUSE IS OR
            BECOMES INVALID, ILLEGAL OR UNENFORCEABLE, SUCH RESPECTIVE
            PROVISIONS SHALL BE SEVERED FROM THE PRIVACY POLICY AND THE PRIVACY
            POLICY SHALL BE READ WITHOUT SUCH UNLAWFUL PROVISIONS.
          </p>
          <h2>18. GREVIENCE REDRESSAL MECHANISM</h2>
          <p>
            In order to address any of Your grievances and / or discrepancies of
            the information displayed on the Website/App, the Website/App shall
            designate the below mentioned grievance redressal officer(s)
            (“Grievance Officer”). The Grievance Officer shall redress all the
            grievances expeditiously but within 1 (one) month from the date of
            receipt of the grievance as provided under the Act.
          </p>
          <p>
            Grievance Redressal Officer Contact Information{" "}
            <b>support@hotelzify.com</b>{" "}
          </p>
          <h2>19. INDEMNITY</h2>
          <div>
            Users shall indemnify, defend and hold Us harmless from and against
            any and all losses, liabilities, claims, damages, demands, costs and
            expenses (including attorney&#39;s fees and disbursements in
            connection therewith and interest chargeable thereon) asserted
            against or incurred by Us that arise out of, result from, or may be
            payable by virtue of any breach or non-performance by Users of any
            of the terms of this Privacy Policy or of the Website/App.
          </div>
          <h2>20. DISCLAIMER</h2>
          <div>
            THE SERVICE IS PROVIDED “AS IS” WITHOUT WARRANTY OF ANY KIND,
            EXPRESS OR IMPLIED. USE OF THE SERVICE IS AT USERS’ SOLE RISK.
            COMPANY DOES NOT WARRANT THAT THE SERVICE WILL BE UNINTERRUPTED OR
            ERROR FREE, NOR DOES COMPANY MAKE ANY WARRANTY AS TO ANY RESULTS
            THAT MAY BE OBTAINED BY USE OF THE SERVICE. COMPANY MAKES NO OTHER
            WARRANTIES, EXPRESS OR IMPLIED, INCLUDING, WITHOUT LIMITATION, ANY
            IMPLIED WARRANTIES OF MERCHANTABILITY OR FITNESS FOR A PARTICULAR
            PURPOSE, IN RELATION TO THE SERVICE.
          </div>
          <h2>21. GOVERNING LAW AND DISPUTE RESOLUTION</h2>
          <div>
            All disputes arising out of this Privacy Policy and any disclaimers
            on the Website shall be subject to the sole and exclusive
            jurisdiction of the courts of New Delhi, India .
          </div>
          <h2>22. CONTACT INFORMATION</h2>
          <div>
            If You have any questions or concerns with respect to this Policy
            any information contained on thereon, You may contact Us by writing
            to Us at <b>support@hotelzify.com</b>. This Privacy Policy
            supersedes any previous versions.
          </div>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
